import { Link } from 'react-router-dom';
import LegalPage, { LEGAL_CONTACT, LegalSection } from './LegalPage';

const mail = <a href={`mailto:${LEGAL_CONTACT}`}>{LEGAL_CONTACT}</a>;

const sections: LegalSection[] = [
  { id: 'collect', heading: 'What we collect', body: <>
    <ul>
      <li><b>Account details</b>: your name, work email, company name and domain, and anything you add to your profile.
        Passwords are stored only in hashed form.</li>
      <li><b>Workspace content</b>: vendors, contacts, questionnaire responses, documents and notes you add.</li>
      <li><b>Public information</b> about the domains you assess, such as DNS records, certificates and website responses.</li>
      <li><b>Usage information</b>: sign-in times, IP address, browser type and a log of actions in your workspace.</li>
    </ul>
  </> },
  { id: 'use', heading: 'How we use it', body: <>
    <p>To run FluxWatch, keep it secure, send you sign-in codes and notifications, provide support and improve the
      product. We do not sell your information or use it for advertising.</p>
  </> },
  { id: 'ai', heading: 'AI providers', body: <>
    <p>AI features use the provider set up for your workspace. The text needed for a request is sent to that provider.
      Saved API keys are encrypted.</p>
  </> },
  { id: 'sharing', heading: 'Who can see it', body: <>
    <p>Your workspace's admins and team members, according to their roles. Vendors you send a questionnaire or request
      to see what you send them. We also use trusted providers for hosting and email delivery.</p>
  </> },
  { id: 'security', heading: 'Security', body: <>
    <p>Data is encrypted in transit, each workspace's data is kept separate, and access follows the roles your admins set.</p>
  </> },
  { id: 'choices', heading: 'Your choices', body: <>
    <p>You can update your profile at any time. To get a copy of your information or have it deleted, email {mail}.</p>
  </> },
  { id: 'storage', heading: 'Browser storage', body: <>
    <p>We use your browser's storage to keep you signed in and remember preferences. No advertising cookies.</p>
  </> },
  { id: 'changes', heading: 'Changes', body: <>
    <p>We may update this policy from time to time. The latest version is always on this page.</p>
  </> },
  { id: 'contact', heading: 'Contact', body: <>
    <p>Questions about privacy: {mail}. See also our <Link to="/terms">Terms of Service</Link>.</p>
  </> },
];

export default function Privacy() {
  return (
    <LegalPage title="Privacy Policy" sections={sections}
      intro={<p>What information FluxWatch collects and how we use it.</p>} />
  );
}
